import { View, Text } from "react-native";
import React from "react";
import { SafeAreaView } from "react-native-safe-area-context";
import { Typography } from "components/ui";
import { Clock } from "lucide-react-native";

const Chat = () => {
	return (
		<SafeAreaView style={{ flex: 1, alignItems: "center", justifyContent: "center", backgroundColor: "#f0f0f0" }}>
			<Clock size={48} color="#333" style={{ marginBottom: 16 }} />
			<Typography.H1 style={{ fontSize: 32, color: "#333", marginBottom: 16 }}>Coming Soon!</Typography.H1>
			<Typography.Paragraph style={{ fontSize: 18, color: "#555", textAlign: "center", paddingHorizontal: 30 }}>We're working hard to bring you this feature. Stay tuned!</Typography.Paragraph>
		</SafeAreaView>
	);
};

export default Chat;
